import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * GA4: load gtag.js from index.html with send_page_view: false, then send page_view from here
 * only when pathname/search changes. Avoids (1) HTML config + listener both counting a view,
 * (2) hash-only or late router updates firing a second hit, (3) duplicate sends in React Strict Mode.
 */
let lastSentPagePathKey = '';

export default function GoogleAnalyticsRouteListener() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
      return;
    }

    const pagePath = `${location.pathname}${location.search}`;

    if (pagePath === lastSentPagePathKey) {
      return;
    }
    lastSentPagePathKey = pagePath;

    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location.pathname, location.search]);

  return null;
}
